module.exports = __webpack_public_path__ + "static/img/energy-h5-3.349e6c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/energy-h5-3.png
// module id = MGT7
// module chunks = 34